








import { Component, Vue } from "vue-property-decorator";
import { ConfigProvider } from "ant-design-vue";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
@Component({
  name: "App",
  components: {
    AConfigProvider: ConfigProvider
  }
})
export default class App extends Vue {
  private zh_CN = zh_CN;
}
